import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import BackButton from '../../components/BackButton';
import RateLimitModal from '../../components/RateLimitModal';
import api from '../../services/api';
import './UtilityPage.css';

const UnitConverter = () => {
  const { isAuthenticated } = useAuth();
  const [value, setValue] = useState('');
  const [category, setCategory] = useState('length');
  const [fromUnit, setFromUnit] = useState('meter');
  const [toUnit, setToUnit] = useState('kilometer');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [showRateLimitModal, setShowRateLimitModal] = useState(false);
  const [rateLimitError, setRateLimitError] = useState(null);

  const units = {
    length: ['meter', 'kilometer', 'centimeter', 'millimeter', 'inch', 'foot', 'yard', 'mile'],
    weight: ['kilogram', 'gram', 'pound', 'ounce', 'ton'],
    volume: ['liter', 'milliliter', 'gallon', 'quart', 'pint', 'cup'],
    temperature: ['celsius', 'fahrenheit', 'kelvin']
  };

  const handleConvert = async () => {
    if (!value) {
      setError('Please enter a value');
      return;
    }

    try {
      setError('');
      const response = await api.post('/api/utilities/converter/unit', {
        value: parseFloat(value),
        category,
        fromUnit,
        toUnit
      });
      setResult(response.data.result);
    } catch (err) {
      if (err.response?.status === 429) {
        const errorData = err.response.data;
        setRateLimitError({
          message: errorData.message || 'Rate limit exceeded',
          isAuthenticated: errorData.isAuthenticated !== undefined ? errorData.isAuthenticated : isAuthenticated,
          suggestion: errorData.suggestion || '',
          currentLimit: errorData.currentLimit || '',
          loginLimit: errorData.loginLimit || '',
          premiumLimit: errorData.premiumLimit || ''
        });
        setShowRateLimitModal(true);
      } else {
        setError(err.response?.data?.error || 'Failed to convert');
        setResult(null);
      }
    }
  };

  return (
    <div className="utility-page">
      <BackButton />
      <div className="utility-container">
        <h1>Unit Converter</h1>
        <div className="utility-form">
          <div className="input-section">
            <label>Category</label>
            <select value={category} onChange={(e) => setCategory(e.target.value)}>
              <option value="length">Length</option>
              <option value="weight">Weight</option>
              <option value="volume">Volume</option>
              <option value="temperature">Temperature</option>
            </select>
          </div>
          <div className="input-section">
            <label>Value</label>
            <input
              type="number"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder="Enter value"
            />
          </div>
          <div className="input-section">
            <label>From</label>
            <select value={fromUnit} onChange={(e) => setFromUnit(e.target.value)}>
              {units[category].map(unit => (
                <option key={unit} value={unit}>{unit}</option>
              ))}
            </select>
          </div>
          <div className="input-section">
            <label>To</label>
            <select value={toUnit} onChange={(e) => setToUnit(e.target.value)}>
              {units[category].map(unit => (
                <option key={unit} value={unit}>{unit}</option>
              ))}
            </select>
          </div>
          <button onClick={handleConvert} className="btn-process">Convert</button>
          {error && <div className="error-message">{error}</div>}
          {result !== null && (
            <div className="output-section">
              <label>Result</label>
              <div className="result-display">
                <strong>{value} {fromUnit} = {result} {toUnit}</strong>
              </div>
            </div>
          )}
        </div>
      </div>
      
      {showRateLimitModal && rateLimitError && (
        <RateLimitModal 
          error={rateLimitError}
          onClose={() => {
            setShowRateLimitModal(false);
            setRateLimitError(null);
          }}
        />
      )}
    </div>
  );
};

export default UnitConverter;

